/** @type {String} Roles */
export const ACCOUNT_OWNER = "account_owner";
export const ADMINISTRATOR = "administrator";
export const MANAGER = "manager";
export const STAFF = "staff";
